import { MEAL_SLOTS, REQUIRED_MEAL_SLOTS, isRequiredMealSlot, isSnackSlot, } from '../meals.types';
export function buildMealStatusSummary(doneSlots) {
    const requiredDoneCount = doneSlots.filter(isRequiredMealSlot).length;
    const requiredSlots = REQUIRED_MEAL_SLOTS.length;
    const snackDoneCount = doneSlots.filter(isSnackSlot).length;
    return {
        doneCount: doneSlots.length,
        totalSlots: MEAL_SLOTS.length,
        doneSlots,
        requiredDoneCount,
        requiredSlots,
        snackDoneCount,
        isComplete: requiredDoneCount === requiredSlots,
    };
}
export function formatMealMapProgressSummary(summary) {
    const base = `${summary.requiredDoneCount}/${summary.requiredSlots} meals`;
    if (summary.snackDoneCount > 0) {
        const snackLabel = summary.snackDoneCount === 1 ? 'snack' : 'snacks';
        return `${base} · ${summary.snackDoneCount} ${snackLabel}`;
    }
    return base;
}
